// @core/api/endpoints/subscription/set_subscription_cancel.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetSubscriptionCancelRequest,
  SubscriptionResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Cancel subscription
 * Initiates subscription cancellation. Can be immediate or scheduled for the end of the billing period. Includes optional reason tracking.
 */
export async function SetSubscriptionCancel(
  subscription_id: string,
  data: SetSubscriptionCancelRequest,
  options?: RequestOptions
): Promise<SubscriptionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/cancel`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.post<SubscriptionResponse>(requestPath, data, requestOptions);
}
